export const SOFTWARE_PRICE_DATA = {
  expand: {
    first: {
      values: ['1', '2-5', '5-10', '10+', 'Other'],
      placeholder: 'How many engineers do you need?',
    },
    second: {
      values: [
        'Up to 3 months',
        '3-6 months',
        '7-12 months',
        '12+ months',
        'Other',
      ],
      placeholder: 'For how long?',
    },
  },
  hire: {
    first: {
      values: [
        'Web development',
        'Mobile development',
        'UX/UI design',
        'Quality assurance',
        'MVP development',
        'Discovery phase',
        'Other',
      ],
      placeholder: 'What service do you need?',
    },
    second: {
      values: [
        'Mobile native (iOS, Android)',
        'Mobile cross-platform',
        'Web',
        'All platforms',
      ],
      placeholder: 'What is your platform?',
    },
  },
};
